import React from 'react';
import styled from 'styled-components'

export const ContainerForm = styled.div`
    padding: 2% 10%;
`;
